// defines position of the vertices
function positionBuffer (sz, sy, sx, sox) {
  const a = sz
  const b = sy
  const c = sox
  const d = sz - sox
  const e = sx 

  return [ 
    a, b, 0, // achter
    0, 0, 0, 
    0, c, 0, 
    0, c, 0, 
    d, b, 0, 
    a, b, 0, 

    0, c, e, // voor 
    0, 0, e, 
    a, b, e, 
    a, b, e, 
    d, b, e, 
    0, c, e,

    a, b, 0, 
    d, b, 0, 
    a, b, e, 
    d, b, 0,
    d, b, e, 
    a, b, e,

    d, b, 0, 
    0, c, 0, 
    d, b, e, 
    0, c, 0, 
    0, c, e, 
    d, b, e, 

    0, c, 0, 
    0, 0, 0, 
    0, c, e, 
    0, 0, 0,
    0, 0, e, 
    0, c, e, 
    
    0, 0, 0, 
    a, b, 0, 
    0, 0, e, 
    a, b, 0, 
    a, b, e, 
    0, 0, e 
  ]
}

// defines position of the textures
function uvBuffer (sz, sy, sx, sox) { 
  const positions = positionBuffer(sz, sy, sx, sox)
  let uvs = []
  const MAX_W = 2330
  const MAX_H =145

  const degToRad = deg => deg * Math.PI / 180;

  // face vertex ranges (each triangle = 3 vertices)
  const faceDefs = [
    { name: "back",   start: 0,  end: 5,  rot:  -45, axes: ["x", "y"] },
    { name: "front",  start: 6,  end: 11, rot:  -45, axes: ["x", "y"] },
    { name: "top",     start: 12, end: 17, rot:  0, axes: ["x", "z"] },
    { name: "right",   start: 18, end: 23, rot:  0, axes: ["y", "z"] },
    { name: "bottom",  start: 24, end: 29, rot:  0, axes: ["x", "z"] },
    { name: "bottom2", start: 30, end: 35, rot:  0, axes: ["x", "z"] },
    // { name: "left",    start: 42, end: 47, rot:  0, axes: ["y", "z"] },
  ];

  let vertexIndex = 0;          // counts vertices, not floats
  for (let i = 0; i < positions.length; i += 3, vertexIndex++) {
    let x = positions[i];
    let y = positions[i + 1];
    let z = positions[i + 2];

    // figure out which face this vertex belongs to
    let face = faceDefs.find(f => vertexIndex >= f.start && vertexIndex <= f.end);
    if (!face) face = { rot: 0, axes: ["x", "y"] }; // fallback

    const angle = degToRad(face.rot);
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);

    // get UV axes
    let a1, a2;
    switch (face.axes[0]) {
      case "x": a1 = -x; break;
      case "y": a1 = -y; break;
      case "z": a1 = -z; break;
    }
    switch (face.axes[1]) {
      case "x": a2 = -x; break;
      case "y": a2 = -y; break;
      case "z": a2 = -z; break;
    }

    // rotate in 2D (in the local plane)
    const u_ = a1 * cos - a2 * sin;
    const v_ = a1 * sin + a2 * cos;

    // scale to UV space
    const u = u_ / MAX_W;
    const v = v_ / MAX_H;

    uvs.push(u, v);
  }
  return uvs
}

// defines orientation of the faces (texture inside or outside)
function normalBuffer () {
  return [ 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, -0.8320503234863281, 0.5547001957893372, 0, -0.8320503234863281, 0.5547001957893372, 0, -0.8320503234863281, 0.5547001957893372, 0, -0.8320503234863281, 0.5547001957893372, 0, -0.8320503234863281, 0.5547001957893372, 0, -0.8320503234863281, 0.5547001957893372, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, 0.7808688282966614, -0.6246950626373291, 0, 0.7808688282966614, -0.6246950626373291, 0, 0.7808688282966614, -0.6246950626373291, 0, 0.7808688282966614, -0.6246950626373291, 0, 0.7808688282966614, -0.6246950626373291, 0, 0.7808688282966614, -0.6246950626373291, 0 ]
}

// group the vertices belonging to each of the 6 sides, allows for 6 different textures one for each side.
function groupBuffer () {
  return [
    {
      start: 0,
      count: 6,
      materialIndex: 0
    },
    {
      start: 6,
      count: 6,
      materialIndex: 1
    },
    {
      start: 12,
      count: 6,
      materialIndex: 2
    },
    {
      start: 18,
      count: 6,
      materialIndex: 3
    },
    {
      start: 24,
      count: 6,
      materialIndex: 4
    },
    {
      start: 30,
      count: 6,
      materialIndex: 5
    }
  ]
}

export { positionBuffer, uvBuffer, normalBuffer, groupBuffer }